newByteLength